import React from 'react';
import classNames from 'classnames';
import { Stack, Text, Divider } from '@moda/om';
import './CheckoutSection.scss';

interface Props {
  className?: string;
  title: string;
  id?: string;
  divider?: boolean;
}

export const CheckoutSection: React.FC<Props> = ({
  children,
  className,
  title,
  id,
  divider = true
}) => (
  <Stack className={classNames('CheckoutSection', className)} space={2}>
    <Text className="CheckoutSection__title" id={id}>
      {title}
    </Text>

    {divider && <Divider />}

    <div className="CheckoutSection__content">{children}</div>
  </Stack>
);
